export const getCategories = state => state.categories.items;
export const isLoadingValue = state => state.categories.isLoading;
